import { Button, Flex, Modal, Text } from '@mantine/core'

import { useIsMobile } from '@/pages/moveManager/hooks/useIsMobile'

const DSModalConfirm = ({
  opened,
  close,
  title,
  content,
  onConfirm,
  children,
  size = 'auto',
  color = 'red',
  disabledConfirm = false,
  autoCloseOnConfirm = true,
}: {
  opened: boolean
  close: () => void
  title: string
  content: string
  onConfirm: () => void
  children?: React.ReactNode
  size?: string
  color?: string
  disabledConfirm?: boolean
  autoCloseOnConfirm?: boolean
}) => {
  const isMobile = useIsMobile()

  const handleConfirm = () => {
    onConfirm()
    if (autoCloseOnConfirm) {
      close()
    }
  }

  const confirmBtn = (
    <Button color={color} disabled={disabledConfirm} fullWidth={isMobile} onClick={handleConfirm}>
      Confirm
    </Button>
  )

  const cancelBtn = (
    <Button color="gray" fullWidth={isMobile} onClick={close}>
      Cancel
    </Button>
  )

  return (
    <Modal
      centered
      opened={opened}
      size={isMobile ? 'calc(100% - 32px)' : size}
      title={
        <Text size="xl" fw="bolder">
          {title}
        </Text>
      }
      onClose={close}
    >
      <Text>{content}</Text>
      {children}
      <Flex
        mt="xl"
        direction={isMobile ? 'column' : 'row'}
        justify={isMobile ? undefined : 'flex-end'}
        gap={isMobile ? 'xs' : 'sm'}
      >
        {/* On mobile, primary action goes first (Confirm above Cancel). */}
        {isMobile ? (
          <>
            {confirmBtn}
            {cancelBtn}
          </>
        ) : (
          <>
            {cancelBtn}
            {confirmBtn}
          </>
        )}
      </Flex>
    </Modal>
  )
}

export default DSModalConfirm
